import colors from './colors';

export type HorizontalLayoutProps = {
  children: React.ReactNode
  gap?: number
  justify?: 'center' | 'space-between' | 'space-around'
  align?: 'center'
  wrap?: 'wrap' | 'wrap-reverse'
  width?: '100%'
  grow?: 1
  color?: keyof typeof colors
  padding?: '10px'
  overflow?: 'scroll'
};

export const HorizontalLayoutUI: React.FC<HorizontalLayoutProps> = ({ children, gap, justify, align, wrap, grow, width, color, padding, overflow }) => {
  const scrollOverride = overflow === 'scroll' ? 'auto' : undefined;
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: justify,
      alignItems: align,
      gap,
      flexWrap: wrap,
      width,
      flexGrow: grow,
      backgroundColor: color ? colors[color] : undefined,
      padding,
      overflowX: scrollOverride,
      scrollbarWidth: 'thin',
    }}
    >
      {children}
    </div>
  );
};
